import * as Schema from "effect/Schema";
import { ManagedGitHost, ManagedRepository } from "./sourceControlConnections.ts";

const Id = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(200));
const Secret = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(65536));
/** Server-to-server only. These values must never enter client snapshots or HTTP traces. */
export const RelaySourceControlAction = Schema.Union([
  Schema.Struct({ action: Schema.Literal("capabilities") }),
  Schema.Struct({
    action: Schema.Literal("start"),
    host: ManagedGitHost,
    accountToken: Secret,
    operationId: Id,
  }),
  Schema.Struct({ action: Schema.Literal("complete"), connectionId: Id, operationId: Id }),
  Schema.Struct({ action: Schema.Literal("confirm"), connectionId: Id }),
  Schema.Struct({
    action: Schema.Literal("repositories"),
    connectionId: Id,
    accessToken: Secret,
    cursor: Schema.optionalKey(Schema.String.check(Schema.isMaxLength(2000))),
  }),
  Schema.Struct({
    action: Schema.Literal("grant"),
    connectionId: Id,
    accessToken: Secret,
    repositoryIds: Schema.Array(Id).check(Schema.isMaxLength(100)),
  }),
  Schema.Struct({
    action: Schema.Literal("token"),
    connectionId: Id,
    repositoryId: Id,
    accessToken: Secret,
  }),
  Schema.Struct({
    action: Schema.Literal("refresh"),
    connectionId: Id,
    refreshToken: Secret,
    operationId: Id,
  }),
  Schema.Struct({ action: Schema.Literals(["status", "disconnect"]), connectionId: Id }),
]);
export type RelaySourceControlAction = typeof RelaySourceControlAction.Type;
export const RelayGitCredential = Schema.Struct({
  accessToken: Secret,
  refreshToken: Schema.optionalKey(Secret),
  expiresAt: Schema.Int,
});
export type RelayGitCredential = typeof RelayGitCredential.Type;
export const RelaySourceControlResult = Schema.Struct({
  connectionId: Id,
  host: ManagedGitHost,
  status: Schema.Literals([
    "connecting",
    "ready",
    "exchanging",
    "connected",
    "reconnect_required",
    "revoked",
    "disconnected",
  ]),
  accountId: Schema.optionalKey(Schema.String),
  accountName: Schema.optionalKey(Schema.String),
  revision: Schema.Int,
  authorizationUrl: Schema.optionalKey(Schema.String),
  installationUrl: Schema.optionalKey(Schema.String),
  hosts: Schema.optionalKey(Schema.Array(ManagedGitHost)),
  credential: Schema.optionalKey(RelayGitCredential),
  repositories: Schema.Array(ManagedRepository),
  nextCursor: Schema.optionalKey(Schema.String),
});
export type RelaySourceControlResult = typeof RelaySourceControlResult.Type;
export class RelaySourceControlError extends Schema.TaggedErrorClass<RelaySourceControlError>()(
  "RelaySourceControlError",
  {
    code: Schema.Literals([
      "unavailable",
      "forbidden",
      "invalid_attempt",
      "reconnect_required",
      "uncertain_exchange",
      "rate_limited",
      "provider_denied",
    ]),
  },
  { httpApiStatus: 409 },
) {}
